import React, { useEffect } from 'react';

import queryString from 'query-string';

const AuthRedirect = () => {
    const parseQueryString = hash => {
        if (hash) {
            return queryString.parse(hash);
        }
        return hash;
    }

    useEffect(() => {
        const message = parseQueryString(window.location.hash)
        window.location.hash = '';
    
        let opener = window.opener
        if (window.parent !== window.top) {
            opener =  opener || window.parent
        }
    
        opener.postMessage(message, window.location.origin);
        window.close();
    }, []);

    return (
        <div></div>
    )
}

export default AuthRedirect;